module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="choose_source">\n    <h3 id="source_header">' +
((__t = ( I18n.t('uploader.source.header') )) == null ? '' : __t) +
'</h3>\n    <div id="source_list">\n        <button id="source_desktop" class="source">\n            <span class="icon"></span>\n            <span class="label">' +
((__t = ( gon.isMobile ? I18n.t('uploader.source.label.mobile') : I18n.t('uploader.source.label.desktop') )) == null ? '' : __t) +
'</span>\n        </button>\n        <button id="source_facebook" class="source" title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'">\n            <span class="icon"></span>\n            <span class="label">' +
((__t = ( I18n.t('uploader.source.label.facebook') )) == null ? '' : __t) +
'</span>\n        </button>\n        <button id="source_google_photos" class="source" title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'">\n            <span class="icon"></span>\n            <span class="label">' +
((__t = ( I18n.t('uploader.source.label.gphotos') )) == null ? '' : __t) +
'</span>\n        </button>\n    </div>\n</div>\n';
 if (infoButton()) { ;
__p += '\n    <button id="info_button">' +
((__t = ( I18n.t('uploader.source.info_button') )) == null ? '' : __t) +
'</button>\n';
 } ;
__p += '\n';

}
return __p
}